/**
 * External dependencies
 */
import React, { memo } from 'react';
import dayjs from 'dayjs';
import Typography from '@mui/material/Typography';
import useTools from '@naruto/naruto-hooks/src/useTools';
import useDate from '@naruto/naruto-hooks/src/useDate';

/**
 * Internal dependencies
 */
import useLang from '@naruto/bgdapp/src/hooks/useLang';

function AllWrite(): React.ReactElement {
  /* Global & Local State */
  const { i18ns } = useLang();
  const { textParser } = useTools();
  const { formatWithTZ } = useDate();

  /* Main */
  return (
    <Typography variant="caption" color="text.disabled">
      {textParser.getFormatString(
        i18ns.__('frontend.global.property.allwrite'),
        `${formatWithTZ(dayjs().toDate(), 'YYYY')}`
      )}
    </Typography>
  );
}

export default memo(AllWrite);
